const aboutData = [
  {
    point:
      " A passionate programmer and a developer, born and brought up in India.",
  },
  { point: " Student at JSSATE Bengaluru [2018-2022] ." },
  { point: " B.E. in Information Science and Engineering ." },
  {
    point:
      "I am a student working on enhancing my skills and learning new things .",
  },
  {
    point:
      "I am currently looking for some internship opportunities to enhance my skills and also gain some good experience.",
  },
  {
    point:
      "I love learning about new technologies, what problems are they solving and How can I use them to build better and scalable products.",
  },
];

export default aboutData;
